import React from 'react';
import { LoadingSkeleton } from '@jbhi-fi/components/src/LoadingSkeleton/LoadingSkeleton';
import { ProductCardSkeletonProps } from '@jbhi-fi/components/src/LoadingSkeleton/variants/ProductCard/ProductCardSkeleton';

const DEFAULT_NUM_HITS = 36;

const ResultsSkeleton = ({ numHits: numHitsProp, ...props }: ProductCardSkeletonProps & { numHits?: number }) => {
  const cache = JSON.parse(sessionStorage.getItem('ais.infiniteHits') ?? '{}');
  const numHits =
    numHitsProp || (cache?.hits ? Object.values(cache.hits)?.flat()?.length || DEFAULT_NUM_HITS : DEFAULT_NUM_HITS);

  return (
    <>
      {[...Array(numHits).keys()].map(index => (
        <LoadingSkeleton.ProductCardSkeleton {...props} key={index} />
      ))}
    </>
  );
};

export default React.memo(ResultsSkeleton);
